import Comment from './src/main';

/* istanbul ignore next */
Comment.install = function(Vue) {
  Vue.component(Comment.name, Comment);
};

export default Comment;
